import { connect } from 'react-redux';

export function getLoggedUser() {
    return JSON.parse(localStorage.getItem('loggedUser'));
}